import React from 'react';
import styled from 'styled-components';
import { Tab } from 'rbx';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import qs from 'querystringify';

import { Box, Tabs, Loading, Message } from '../../../components/elements';
import client from '../../../utils/apolloClient';
import Header from './Header';
import Layout from '../../../components/global/Layout';

import StripeBlockUser from './StripeBlockUser';

const HeaderWrapper = styled.div`
  position: sticky;
  top: 3.2rem;
  background-color: #fff;
  z-index: 10;
`;

const userQuery = gql`
  query user($userId: String!) {
    fetch_user(input: { user_id: $userId }) {
      user_id
      object_id
      first_name
      last_name
      display_name
      preferred_username
      email
      date_of_birth
      gender
      description
      status
      user_handle
      external_payment_id
      visibility
      rating
      image_url
      contact {
        type
        value
        display
        display_order
        is_primary
      }
      access {
        place_id
      }
      address {
        address_id
        type
        is_default
        contact_name
        contact_phone
        address_line_1
        address_line_2
        city
        state
        country
        post_code
        latitude
        longitude
        location
        timezone
      }
      audit {
        created_at
        created_by
        updated_at
        updated_by
      }
    }
  }
`;

const View = ({ match, location }) => {
  const routeState = qs.parse(location.search);
  const { tab } = routeState;

  const activeTab = tab || 'blockUser';

  const { loading, error, data } = useQuery(userQuery, {
    variables: { userId: match.params.userId },
    client: client.clientPrivate,
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Message>{error.message}</Message>;
  }

  const user = data.fetch_user;

  return (
    <React.Fragment>
      <Header user={user} />
      <HeaderWrapper>
        <Box>
          <Tabs className="tabs is-large">
            <Tab active>Block User</Tab>
          </Tabs>
        </Box>
      </HeaderWrapper>
      <Box>
        {activeTab === 'blockUser' && (
          <StripeBlockUser
            userId={user.user_id}
            user={user}
            stripeBlockUserId={match.params.blockuserId}
          />
        )}
      </Box>
    </React.Fragment>
  );
};

const BlockUser = props => (
  <Layout>
    <View {...props} />
  </Layout>
);

export default BlockUser;
